/* @flow */

export default {
  ACTIVITY_TYPE_PARTS: 'default.activity.parts',
  ACTIVITY_TYPE_SALES: 'default.activity.sales',
  ACTIVITY_TYPE_SERVICE: 'default.activity.service',
  ACTIVITY_TYPE_USED_VEHICLES: 'default.activity.usedVehicles',
  ACTIVITY_PARTS_LABEL: 'default.activity.parts.label',
  ACTIVITY_SALES_LABEL: 'default.activity.sales.label',
  ACTIVITY_SERVICE_LABEL: 'default.activity.service.label',
  ACTIVITY_USED_VEHICLES_LABEL: 'default.activity.usedVehicles.label',
  HIGHLIGHTED_ICON_AMG: 'default.highlightedIcon.amg',
  HIGHLIGHTED_ICON_ECQ: 'default.highlightedIcon.eqc',
  HIGHLIGHTED_ICON_ECQ_CHARGER: 'default.highlightedIcon.eqcCharger',
  HIGHLIGHTED_ICON_PARTS_PRO: 'default.highlightedIcon.partsPro',
  HIGHLIGHTED_ICON_WEBPARTS: 'default.highlightedIcon.webParts',
  HIGHLIGHTED_ICON_JUNGE_STERNE: 'default.highlightedIcon.jungeSterne',
  HIGHLIGHTED_ICON_MB_CERTIFIED: 'default.highlightedIcon.mbCertified',
  HERE_MAPS_LANGUAGE: 'default.maps.here.language',
  PREFIX_PHONE: 'default.prefix.phone.label',
  PREFIX_FAX: 'default.prefix.fax.label',
  PREFIX_EMAIL: 'default.prefix.email.label',
  PRODUCT_GROUP_BUS_LABEL: 'default.productGroup.bus.label',
  PRODUCT_GROUP_PASSENGER_CAR_LABEL: 'default.productGroup.passengerCar.label',
  PRODUCT_GROUP_TRUCK_LABEL: 'default.productGroup.truck.label',
  PRODUCT_GROUP_UNIMOG_LABEL: 'default.productGroup.unimog.label',
  PRODUCT_GROUP_VAN_LABEL: 'default.productGroup.van.label',
  WEEKDAY_MONDAY: 'default.weekday.monday.label',
  WEEKDAY_TUESDAY: 'default.weekday.tuesday.label',
  WEEKDAY_WEDNESDAY: 'default.weekday.wednesday.label',
  WEEKDAY_THURSDAY: 'default.weekday.thursday.label',
  WEEKDAY_FRIDAY: 'default.weekday.friday.label',
  WEEKDAY_SATURDAY: 'default.weekday.saturday.label',
  WEEKDAY_SUNDAY: 'default.weekday.sunday.label',
  DISTANCE_UNIT_KM: 'default.distanceUnit.km',
  DISTANCE_UNIT_MI: 'default.distanceUnit.mi',
  DISTANCE_UNIT_M: 'default.distanceUnit.m',
  DISTANCE_UNIT_YD: 'default.distanceUnit.yd',
  DEALERS_SEARCH_TAB_LABEL_LOCATION: 'default.search.tab.label.location',
  DEALERS_SEARCH_TAB_LABEL_NAME: 'default.search.tab.label.name',
  DEALERS_SEARCH_SUBMIT_BUTTON_LABEL: 'default.search.submit.button.label',
  DEALERS_SEARCH_FIELD_PLACEHOLDER_LOCATION: 'default.search.field.placeholder.location',
  DEALERS_SEARCH_FIELD_PLACEHOLDER_NAME: 'default.search.field.placeholder.name',
  DEALERS_SEARCH_FIELD_NO_SUGGESTIONS: 'default.search.field.noSuggestions.label',
  DEALER_PORTFOLIO_HEADLINE: 'default.dealer.portfolio.headline',
  DEALER_PORTFOLIO_NO_INFO: 'generic.dealer.portfolio.noInfo.label',
  DEALER_CONTACTS_HEADLINE: 'default.dealer.contacts.headline',
  UNSUPPORTED_BROWSER_WARNING: 'generic.unsupportedBrowser.label',
  MAP_GESTURES_ZOOM_TOUCH_LABEL: 'generic.map.gestures.zoom.touch',
  MAP_GESTURES_ZOOM_SCROLL_LABEL: 'generic.map.gestures.zoom.scroll',
  MAP_GESTURES_ZOOM_SCROLL_MAC_LABEL: 'generic.map.gestures.zoom.scrollMac',
  PARAGRAPH_RESULTS_COUNT: 'generic.paragraph.resultsCount.label',
  PARAGRAPH_RESULTS_COUNT_SINGULAR: 'generic.paragraph.resultsCount.singular.label',

  FILTERING_SEARCH_RADIUS: 'generic.filters.searchRadius',
  FILTERING_SEARCH_RADIUS_LABEL: 'generic.filters.searchRadius.label',
  FILTERING_ACTIVITY_TYPES: 'generic.filters.activityTypes',
  FILTERING_ACTIVITY_TYPES_LABEL: 'generic.filters.activityTypes.label',
  FILTERING_PRODUCT_GROUPS: 'generic.filters.productGroups',
  FILTERING_PRODUCT_GROUPS_LABEL: 'generic.filters.productGroups.label',

  PRODUCT_GROUP_DROPDOWN_DESCRIPTION_LABEL: 'default.filters.productGroup.description.label',
  ACTIVITY_TYPE_DROPDOWN_DESCRIPTION_LABEL: 'default.filters.activityTypes.description.label',
};
